<template>
  <div class="fa-blankslate  pt-5">
    <div class="row">
      <div class="col-sm-12">
        <img v-if="isMobileAndroid()" alt="banner" src="../../../../../assets/images/svg/img-android.jpg"  class="img-responsive">
        <img v-if="isMobileIphone()" alt="banner" src="../../../../../assets/images/svg/img-iphone.jpg"  class="img-responsive">
        <img  v-if="!isMobileIphone() && !isMobileAndroid()"  alt="banner" src="../../../../../assets/images/svg/img-sequislogo.svg"  class="img-responsive"  style="padding-bottom:26px;">
      </div>
      <div class="col-sm-12 c1" style="padding-left: 15%;padding-right: 15%;font-size: 20px;">
        Request Anda sudah kami terima.
      </div>
      <div class="col-sm-12 c2 pt-1" style="padding-top:16px !important;font-size: 16px;">
        Selagi menunggu agen kami menghubungi Anda, silakan download Sequis App untuk melihat status request Anda.
      </div>
       <div class="col-sm-12 c2 pt-1">
        <a v-if="isMobileAndroid()" href="https://sequis.page.link/install_app" @click="onTracking('play_store')">
          <img alt="banner" src="../../../../../assets/images/svg/google-play.svg"  class="img-responsive">
        </a>
        <a v-if="isMobileIphone()" href="https://sequis.page.link/install_app">
          <img alt="banner" src="../../../../../assets/images/svg/app-store.svg"  class="img-responsive" @click="onTracking('app_store')">
        </a>
        <template v-if="!isMobileIphone() && !isMobileAndroid()" >
          <a href="https://sequis.page.link/install_app">
          <img alt="banner" src="../../../../../assets/images/svg/google-play.svg"  class="img-responsive"  @click="onTracking('play_store')" style="padding-top:50px;">
          </a>
          <a href="https://sequis.page.link/install_app">
            <img  alt="banner" src="../../../../../assets/images/svg/app-store.svg"  class="img-responsive" @click="onTracking('app_store')" style="padding-top:50px;">
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessSlate',
  methods: {
    onTracking(app) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_button",
        label: app,
        category: 'form'
      });
    },
    isMobileAndroid() {
      if(/Android/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    isMobileIphone() {
      if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
};
</script>